import { optimove } from 'js/analytics/adapters'
export const trackErrorMessage = ({
  code: error_code,
  type: error_type,
  category: error_category,
}) => {
  optimove.track('receive_error', {
    error_code,
    error_type,
    error_category,
  })
}
